import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { CommonModule } from "@angular/common";
import { CoreModule } from "../core/core.module";
import { createCustomElement } from "@angular/elements";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Injector, NgModule } from "@angular/core";
import { LeafletModule } from "@asymmetrik/ngx-leaflet";
import { NgPipesModule } from "ngx-pipes";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { PathModule } from "../path/path.module";
import { PathTestModule } from "../path-test/path-test.module";
import { PopoverModule } from "ngx-bootstrap/popover";
import { ReactiveComponentModule } from "@ngrx/component";
import { ScoutModule } from "../scout/scout.module";
import { SharedModule } from "../shared/shared.module";
import { TabsModule } from "ngx-bootstrap/tabs";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { NgxPrintModule } from 'ngx-print';

import { VolunteerChooserModal } from "./components/volunteer-chooser.modal";
import { VolunteerEditComponent } from "./volunteer-edit/volunteer-edit.component";
import { VolunteerListComponent } from "./volunteer-list/volunteer-list.component";
import { VolunteerTaskPointComponent } from "./volunteer-task-point/volunteer-task-point.component";
import { VolunteerTaskPointTestParamsComponent } from "./volunteer-task-point/volunteer-task-point-test-params/volunteer-task-point-test-params.component";
import { VolunteerTaskPointTestParamsModalComponent } from "./volunteer-task-point/volunteer-task-point-test-params-modal/volunteer-task-point-test-params-modal.component";
import { VolunteerTaskPointsComponent } from "./volunteer-task-points/volunteer-task-points.component";
import { VolunteerTaskPointsTableComponent } from "./volunteer-task-points/volunteer-task-points-table.component";
import { VolunteerRoutingModule } from "./volunteer-routing.module";
import { VolunteerStatusChooserModal } from "./components/volunteer-status-chooser.modal";
import { VolunteerTaskComponent } from "./volunteer-task/volunteer-task.component";
import { VolunteerTaskEditComponent } from "./volunteer-task-edit/volunteer-task-edit.component";
import { VolunteerTaskListComponent } from "./volunteer-task-list/volunteer-task-list.component";
import { VolunteerHandsetListComponent } from "./volunteer-handset-list/volunteer-handset-list.component";
import { VolunteerPointListComponent } from "./volunteer-point-list/volunteer-point-list.component";
import { VolunteerTaskMapComponent } from "./volunteer-task-map/volunteer-task-map.component";
import { VolunteerTaskMapOverlayComponent } from "./volunteer-task-map/volunteer-task-map-overlay.component";
import { VolunteerTaskPointMarkerPopupComponent } from "./volunteer-task-map/volunteer-task-point-marker-popup/volunteer-task-point-marker-popup.component";
import { VolunteerTasksTableComponent } from "./volunteer-task-list/volunteer-tasks-table.component";
import { PostProcessingModule } from "../post-processing/post-processing.module";
import { VolunteerTaskSeriesComponent } from './components/volunteer-task-series/volunteer-task-series.component';
import { VolunteerHandsetsTableComponent } from "./volunteer-handset-list/volunteer-handsets-table.component";
import { VolunteerPointsTableComponent } from "./volunteer-point-list/volunteer-points-table.component";

@NgModule({
  declarations: [
    VolunteerChooserModal,
    VolunteerEditComponent,
    VolunteerListComponent,
    VolunteerTaskPointComponent,
    VolunteerTaskPointTestParamsComponent,
    VolunteerTaskPointTestParamsModalComponent,
    VolunteerTaskPointsComponent,
    VolunteerTaskPointsTableComponent,
    VolunteerStatusChooserModal,
    VolunteerTaskComponent,
    VolunteerTaskEditComponent,
    VolunteerTaskListComponent,
    VolunteerHandsetListComponent,
    VolunteerPointListComponent,
    VolunteerTaskMapComponent,
    VolunteerTaskMapOverlayComponent,
    VolunteerTaskPointMarkerPopupComponent,
    VolunteerHandsetsTableComponent,
    VolunteerPointsTableComponent,
    VolunteerTasksTableComponent,
    VolunteerTaskSeriesComponent,
  ],
    imports: [
        BsDropdownModule.forRoot(),
        CommonModule,
        CoreModule,
        FormsModule,
        LeafletModule,
        NgPipesModule,
        PaginationModule.forRoot(),
        NgxPrintModule,
        PathModule,
        PathModule,
        PathTestModule,
        PopoverModule.forRoot(),
        ReactiveComponentModule,
        ReactiveFormsModule,
        PostProcessingModule,
        ScoutModule,
        SharedModule,
        TabsModule.forRoot(),
        TooltipModule.forRoot(),
        VolunteerRoutingModule,
    ],

  exports: [
    VolunteerEditComponent,
    VolunteerListComponent,
    VolunteerTaskPointsComponent,
    VolunteerTaskComponent,
    VolunteerHandsetListComponent,
    VolunteerPointListComponent,
    VolunteerTaskListComponent,
  ],

  entryComponents: [ VolunteerTaskPointMarkerPopupComponent ]
})
export class VolunteerModule {
  constructor(private injector: Injector) {
    // For plotter marker popup angular integration with leaflet map
    const popupElement = createCustomElement(VolunteerTaskPointMarkerPopupComponent, {injector});
    customElements.define('app-volunteer-task-point-marker-popup-element', popupElement);
  }
 }
